<div 
  class="flex min-w-0 flex-auto flex-col items-center sm:justify-center dark:bg-gray-900"
  *transloco="let t"
>
  <div class="w-full px-4 py-8 sm:bg-card sm:w-auto sm:rounded-2xl sm:p-12 sm:shadow">
    <div class="mx-auto w-full max-w-2xl sm:mx-0 sm:w-120">

      <!-- 🔹 Smaller Logo if linkData is present -->
      <img
        *ngIf="!linkData"
        src="images/logo/logo-text.png"
        alt="Logo"
        class="block dark:hidden mb-4 max-w-xs mx-auto"
      />
      <img
        *ngIf="!linkData"
        src="images/logo/logo-text-on-dark.png"
        alt="Logo"
        class="hidden dark:block mb-4 max-w-xs mx-auto"
      />
      
      <!-- 🔹 Compact Logo for preview mode -->
      <img
        *ngIf="linkData"
        src="images/logo/logo-text.png"
        alt="Logo"
        class="block dark:hidden mb-2 w-40 mx-auto"
      />
      <img
        *ngIf="linkData"
        src="images/logo/logo-text-on-dark.png"
        alt="Logo"
        class="hidden dark:block mb-2 w-40 mx-auto"
      />

      <!-- 🔸 Link Preview Card -->
      <div 
        *ngIf="linkData" 
        class="bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-2xl shadow-xl px-4 py-6 sm:px-8 mt-4 max-w-3xl mx-auto w-full"
        >
        <div class="flex flex-col items-center sm:flex-row sm:items-center sm:justify-center gap-6 mt-2">
          <div class="text-center sm:text-left flex-1">
            <h1 class="text-xl sm:text-2xl font-extrabold text-gray-900 dark:text-white leading-tight">
              {{ linkData.productTitle }}
            </h1>
            <p class="mt-2 text-gray-700 dark:text-gray-300 text-sm sm:text-base">
              {{ linkData.productSubtitle }}
            </p>
          </div>
          <div class="w-24 sm:w-32 flex-shrink-0">
            <img class="w-full rounded-lg border border-gray-300 dark:border-gray-600 object-cover"
              [src]="linkData.productCoverImage" alt="Cover" />
          </div>
        </div>

        <hr class="my-4 border-gray-300 dark:border-gray-600" />

        @if(linkData.groupId){
        <div class="mt-2 text-center sm:text-left" *transloco="let t">
          <p class="text-gray-700 dark:text-gray-300 text-sm sm:text-base">
            {{ t('pages.amplify-login.link-preview.group-title') }}
            <span  class="font-semibold text-primary dark:text-primary-light text-base sm:text-lg">
              {{ linkData.groupName }}
            </span>. {{ t('pages.amplify-login.link-preview.continue-text') }}
          </p>
        </div>
      }@else {
        <div class="mt-2 text-center sm:text-left" *transloco="let t">
          <p class="text-gray-700 dark:text-gray-300 text-sm sm:text-base">
            {{ t('pages.amplify-login.link-preview.continue-text') }}
          </p>
        </div>
      }
      </div>

      <!-- 🔸 Login Headline -->
      <div class="mt-6 text-3xl font-bold tracking-tight text-center text-gray-900 dark:text-white" *ngIf="!linkData">
        {{ t('pages.amplify-login.welcome-to') }} {{ t('pages.amplify-login.platform-name') }}
      </div>
      <div class="mt-2 text-lg font-medium text-center text-gray-500 dark:text-gray-400" *ngIf="!linkData">
        {{ t('pages.amplify-login.welcome-subtitle') }}
      </div>


      <!-- 🔹 Auth Container -->
      <div class="mt-8 auth-container" *ngIf="showComponent;">
        <amplify-authenticator [signUpAttributes]="['name']">
          <ng-template
            amplifySlot="authenticated"
            let-user="user"
            let-signOut="signOut"
          >
          </ng-template>
        </amplify-authenticator>
      </div>
      
      <div class="mt-4 flex justify-center" *ngIf="authLoading">
        <mat-spinner
          class="text-primary dark:text-primary-light"
          [diameter]="40"
          [strokeWidth]="4"
        ></mat-spinner>
      </div>

      <!-- Language Selector -->
      <languages class="mt-6 mx-auto" />
    </div>
  </div>
</div>
